import { render } from "./KSUslugeEng.vue?vue&type=template&id=0e699466&scoped=true&lang=html"
import script from "./KSUslugeEng.vue?vue&type=script&lang=js"
export * from "./KSUslugeEng.vue?vue&type=script&lang=js"

import "./KSUslugeEng.vue?vue&type=style&index=0&id=0e699466&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0e699466"

export default script